import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/copy': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M433.9 65.9c7.8 7.8 14.1 23 14.1 33.9v268.1c0 26.5-21.5 48-48 48h-80v48c0 26.5-21.5 48-48 48h-224c-26.5 0-48-21.5-48-48v-320c0-26.5 21.5-48 48-48h80v-48c0-26.5 21.5-48 48-48h172.1c11 0 26.2 6.3 33.9 14.1zM266 464c3.3 0 6-2.7 6-6v-42h-96c-26.5 0-48-21.5-48-48v-224h-74c-3.3 0-6 2.7-6 6v308c0 3.3 2.7 6 6 6h212zM394 368c3.3 0 6-2.7 6-6v-202h-88c-13.3 0-24-10.7-24-24v-88h-106c-3.3 0-6 2.7-6 6v308c0 3.3 2.7 6 6 6h212zM400 112v-9.6 0c0-1.4-0.8-3.3-1.8-4.2l-48.4-48.4c-1.1-1.1-2.7-1.8-4.2-1.8h-9.6v64h64z'
      }
    ]
  }
})
